import Swiper, { Navigation, Pagination, Autoplay, EffectFade, Thumbs, EffectCoverflow } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs, EffectCoverflow]);

export const generateSlider = (selector, settings) => {
  const elements = document.querySelectorAll(selector);

  if (elements.length) {
    let slider = new Swiper(selector, settings);

    setTimeout(() => {
      const updatedElements = document.querySelectorAll(selector);

      if (updatedElements.length) {
        if (Array.isArray(slider)) {
          slider.forEach(single => single.update());
        } else {
          slider.update();
        }

        const thumbs = document.querySelector('.gallery-thumbs');
        const imageBoxes = document.querySelectorAll('.gallery-thumbs .image-box');

        if (thumbs && imageBoxes.length < 5) {
          thumbs.classList.add('no-nav');
        }
      }
    }, 1000);
  }
};



// WEBPACK FOOTER //
// ./scripts/exports/generateSwiper.js